import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AirportAutocomplete from "../AirportAutocomplete";
import moment from "moment";
import MESSAGES from "../../constants/Messages";
import { FORM_FIELDS, AUTOCOMPLETE_TYPE } from "../../constants";
import CommonInput from "../../common/Resusable/CommonInput";
import AppCalendar from "../../common/Calendar";
import plusIcon from '../../assets/images/plusBlue.svg';
import deleteIcon from "../../assets/images/delete_icon_red.png";

const validateRequired = (value, setFlightDetailsError, key, index) => {
    const isValuePresent = typeof value === "string" && value.trim().length !== 0;

    setFlightDetailsError((prev) => {
        const updated = new Map(prev);
        const errorObj = { ...(updated.get(index) || {}) };

        errorObj[key] = isValuePresent ? null : MESSAGES.FIELD_REQUIRED;

        updated.set(index, errorObj);
        return updated;
    });
};

const MutlipleBookingFlightSection = ({
    flightDetailsData,
    setFlightDetailsData,
    setNotificationMessage,
    setNotificationType,
    flightDetailsError,
    setFlightDetailsError,
    isMultipleBookingEdit
}) => {
    const { t, i18n } = useTranslation(["labels", "errors"]);
    const [flightLegArray, setFlightLegArray] = useState(null);

    const handleSetError = (key, text, index) => {
        setFlightDetailsError((prev) => {
            const updated = new Map(prev);
            const errorObj = { ...(updated.get(index) || {}) };
            errorObj[key] = text;
            updated.set(index, errorObj);
            return updated;
        });
    };

    const clearError = (key, index) => {
        setFlightDetailsError((prev) => {
            const updated = new Map(prev);
            const errorObj = updated.get(index);

            if (errorObj) {
                errorObj[key] = null;
                updated.set(index, errorObj);
            }

            return updated;
        });
    };

    const handleOnChangeCommon = (index, value, key) => {
        if (value) {
            clearError(key, index);
        }
        const updated = flightLegArray.map((item, i) =>
            i === index ? { ...item, [key]: value } : item
        );
        setFlightLegArray(updated);
        setFlightDetailsData(updated);
    };

    const handleAddFlights = (e) => {
        e.preventDefault();
        const updatedFlightLegArray = [
            ...flightLegArray, {
                origin: null,
                destination: null,
                flightDate: null,
                allotmentId: null,
                flightNumber: null,
            }]
        setFlightLegArray(updatedFlightLegArray);
        setFlightDetailsData(updatedFlightLegArray);

    }

    const handleRemoveItem = (index) => {
        const updatedFlightLegArray = flightLegArray.filter((_, i) => i !== index);
        setFlightLegArray(updatedFlightLegArray);
        setFlightDetailsData(updatedFlightLegArray);
        setFlightDetailsError((prev) => {
            const updated = new Map(prev);
            updated.delete(index);
            return updated;
        });
    }

    useEffect(() => {
        if (flightDetailsData) {
            setFlightLegArray(flightDetailsData);
        }
    }, [flightDetailsData]);


    return (
        <div className="flight-details-row">
            <h3>{t("BOOKING.FLIGHT_INFORMATION")}</h3>
            <div className="form-container">
                {flightLegArray?.map((flightVal, ind) => (
                    <div className="cargo-dimensions-row" key={`key-${ind}`}>
                        <label className="sub-head-label">{`Leg ${ind + 1}`}</label>
                        <div className="flight-input-row">
                            <div
                                className={`form-group common-autocomplete ${flightDetailsError?.get(ind)?.[FORM_FIELDS.ORIGIN] ? "red-border" : ""
                                    }`}
                            >
                                <div className="p-float-label input-wrapper ">
                                    <AirportAutocomplete
                                        autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
                                        selectedOrigin={flightVal?.origin}
                                        selectedDestination={flightVal?.destination}
                                        setSelectedDestination={(e) =>
                                            handleOnChangeCommon(ind, e, "destination")
                                        }
                                        setSelectedOrigin={(e) =>
                                            handleOnChangeCommon(ind, e, "origin")
                                        }
                                        handleSetError={(key, text) =>
                                            handleSetError(key, text, ind)
                                        }
                                        clearError={(e) => clearError(e, ind)}
                                        draftCallback={() => { }}
                                        setNotificationMessage={setNotificationMessage}
                                        setNotificationType={setNotificationType}
                                        displaySimilarBooking={false}
                                    />
                                    <label>{t("CHOOSE_FLT.FROM")}</label>
                                </div>
                                <span className="common-input-error">
                                    {flightDetailsError?.get(ind)?.[FORM_FIELDS.ORIGIN]
                                        ? t(flightDetailsError.get(ind)[FORM_FIELDS.ORIGIN], { ns: "errors" })
                                        : ""}
                                </span>
                            </div>
                            <div
                                className={`form-group common-autocomplete ${flightDetailsError?.get(ind)?.[FORM_FIELDS.DESTINATION]
                                    ? "red-border"
                                    : ""
                                    }`}
                            >
                                <div className="p-float-label input-wrapper">
                                    <AirportAutocomplete
                                        autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
                                        selectedOrigin={flightVal?.origin}
                                        selectedDestination={flightVal?.destination}
                                        setSelectedDestination={(e) =>
                                            handleOnChangeCommon(ind, e, "destination")
                                        }
                                        setSelectedOrigin={(e) =>
                                            handleOnChangeCommon(ind, e, "origin")
                                        }
                                        handleSetError={(key, text) =>
                                            handleSetError(key, text, ind)
                                        }
                                        clearError={(e) => clearError(e, ind)}
                                        draftCallback={() => { }}
                                        setNotificationMessage={setNotificationMessage}
                                        setNotificationType={setNotificationType}
                                        displaySimilarBooking={false}
                                    />
                                    <label>{t("PERMANENT_BOOKING.TO")}</label>
                                </div>
                                <span className="common-input-error">
                                    {flightDetailsError?.get(ind)?.[FORM_FIELDS.DESTINATION]
                                        ? t(flightDetailsError.get(ind)[FORM_FIELDS.DESTINATION], {
                                            ns: "errors",
                                        })
                                        : ""}
                                </span>
                            </div>
                            <div className={`form-group calendar-group `}>
                                <AppCalendar
                                    id="flight-date-calender"
                                    label={t("PERMANENT_BOOKING.DATE")}
                                    value={flightVal.flightDate}
                                    onChangeHandler={(e) => {
                                        handleOnChangeCommon(
                                            ind,
                                            e,
                                            "flightDate"
                                        )
                                        if (e) {
                                            clearError(FORM_FIELDS.SHIPPING_DATE, ind)
                                        }
                                    }
                                    }
                                    minDate={moment().toDate()}
                                    onErrorHandler={() => {
                                        handleSetError(
                                            FORM_FIELDS.SHIPPING_DATE,
                                            MESSAGES.INVALID_SHIPPING_DATE,
                                            ind
                                        );
                                    }}
                                    onFocusHandler={() =>
                                        clearError(FORM_FIELDS.SHIPPING_DATE, ind)
                                    }
                                    error={
                                        flightDetailsError?.get(ind)?.[FORM_FIELDS.SHIPPING_DATE]
                                            ? t(flightDetailsError.get(ind)[FORM_FIELDS.SHIPPING_DATE], {
                                                ns: "errors",
                                            })
                                            : ""
                                    }
                                />
                            </div>
                        </div>
                        <div className="flight-input-row">
                            <div className={`form-group`}>
                                <CommonInput
                                    label={t("COMMON.FLT_NO")}
                                    type="text"
                                    value={flightVal?.flightNumber}
                                    id="FlightNo"
                                    onChange={(e) =>
                                        handleOnChangeCommon(ind, e.target.value, "flightNumber")
                                    }
                                    onBlur={(e) => {
                                        validateRequired(
                                            e.target.value,
                                            setFlightDetailsError,
                                            "FlightNo",
                                            ind
                                        );
                                    }}
                                    error={
                                        flightDetailsError?.get(ind)?.["FlightNo"]
                                            ? t(flightDetailsError.get(ind)["FlightNo"], { ns: "errors" })
                                            : ""
                                    }
                                    onFocus={() => {
                                        clearError("FlightNo", ind);
                                    }}
                                />
                            </div>
                            <div className={`form-group`}>
                                <CommonInput
                                    label={t("DASHBOARD.ALLMNT")}
                                    type="text"
                                    id="AllotmentId"
                                    value={flightVal?.allotmentId}
                                    onChange={(e) =>
                                        handleOnChangeCommon(ind, e.target.value, "allotmentId")
                                    }
                                    onBlur={(e) => {
                                        validateRequired(
                                            e.target.value,
                                            setFlightDetailsError,
                                            "AllotmentId",
                                            ind
                                        );
                                    }}
                                    onFocus={() => {
                                        clearError('AllotmentId', ind);
                                    }}
                                    error={
                                        flightDetailsError?.get(ind)?.["AllotmentId"]
                                            ? t(flightDetailsError.get(ind)["AllotmentId"], { ns: "errors" })
                                            : ""
                                    }
                                />
                            </div>
                            {flightLegArray?.length > 1 && ind !== 0 &&
                                <div className={`form-group`}>
                                    <div className='delete-section' onClick={(e) => handleRemoveItem(ind)}>
                                        <img
                                            src={deleteIcon}
                                            alt='Trash'
                                            title='Trash'
                                        />
                                        <span>{t('COMMON.DELETE')}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                ))}
                 {!isMultipleBookingEdit && (
                <div className='add-more-btn' onClick={(e) => handleAddFlights(e)}>
                    <img className='add-more-plus' src={plusIcon} alt='plus' title='add-more-plus' />
                    <a className={`add-more-link`}>
                        {t('PERMANENT_BOOKING.ADD_ANOTHER_FLIGHT')}
                    </a>
                </div>
                 )}
            </div>

        </div >
    );
};

export default MutlipleBookingFlightSection;
